module.exports = __webpack_public_path__ + "static/media/clooger-2.8b6e77dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/clooger-2.jpg
// module id = 371
// module chunks = 0